// Feed-Check-Flow-Marker: ueberlebt die Magic-Link-Landung (?flow=feedcheck)
// bis zum Wizard-Abschluss. Key-Schema wie die uebrigen feed-optimizer-* Keys.
const FLOW_KEY = 'feed-optimizer-flow';
const FLOW_TS_KEY = 'feed-optimizer-flow-ts';

// Marker verfaellt nach 24h (Review-Finding): Bestandskunden mit vorhandenem
// Merchant Center sehen den Wizard nie, dessen onSuccess-Clear laeuft also nie.
// Ohne TTL wuerde jeder spaetere manuelle Sync dauerhaft als Feed-Check-Sync
// geflaggt (trg_feed_check_score -> wiederkehrende Report-Mails). Zusaetzlich
// verbraucht FeedHealthDashboard den Marker beim ersten Report-View.
const FLOW_TTL_MS = 24 * 60 * 60 * 1000;

export type FlowIntent = 'feedcheck';

export function captureFlowIntent(): void {
  const url = new URL(window.location.href);
  const flow = url.searchParams.get('flow');
  if (flow !== 'feedcheck') return;
  localStorage.setItem(FLOW_KEY, flow);
  localStorage.setItem(FLOW_TS_KEY, String(Date.now()));
  url.searchParams.delete('flow');
  window.history.replaceState({}, '', url.pathname + url.search + url.hash);
}

export function getFlowIntent(): FlowIntent | null {
  if (localStorage.getItem(FLOW_KEY) !== 'feedcheck') return null;
  const ts = Number(localStorage.getItem(FLOW_TS_KEY));
  // Kein/ungueltiger Timestamp (Marker aus einer Version vor dem TTL) oder
  // abgelaufen -> Marker verwerfen statt ihn ewig wirken zu lassen.
  if (!Number.isFinite(ts) || ts <= 0 || Date.now() - ts > FLOW_TTL_MS) {
    clearFlowIntent();
    return null;
  }
  return 'feedcheck';
}

export function clearFlowIntent(): void {
  localStorage.removeItem(FLOW_KEY);
  localStorage.removeItem(FLOW_TS_KEY);
}
